import { customerApiWithOptionalCode } from './base/api-with-optional-code'

const getSharedCustomerWaterUsage = customerApiWithOptionalCode('water-usage')

export default getSharedCustomerWaterUsage